<template>
<div class="ee-card"><slot></slot></div>
</template>
<script>
  export default {
    compName: 'ee-card'
  }
</script>
<style src="../style/card.css"></style>



// WEBPACK FOOTER //
// src/packages/card/Card.vue?b2afe694